import apiClient from "../../utils/api.client";
import { organization } from "../../config/strings";
import { getSaaId } from "../../utils/session.utils";

export const getUnreadCount = async (agencyId) => {
  try {
    const response = await apiClient.get(
      `/gamma-agencies/mailbox/inbox/agency/${agencyId}?page=0&size=1000`
    );
    const content = response.data?.content ?? [];
      return content.filter((m) => !m.isRead).length;
  } catch (error) {
    return 0;
  }
};

export const getMails = async (params) => {
  try {
    // Filtro por categoría: solo se agrega mailboxKindId si viene definido (retrocompatible)
    const kindQuery = params.mailboxKindId !== undefined
      ? `&mailboxKindId=${params.mailboxKindId}`
      : "";
    const response = await apiClient.get(
      `/gamma-agencies/mailbox/inbox/agency/${params.agencyId}?page=${params.page}&size=${params.size}${kindQuery}`
    );
    const data = response.data;
    return data;
  } catch (error) {
    throw new Error(error);
  }
}

export const getMailById = async (mailId, agencyId) => {
  try {
    const endpoint = agencyId != null
      ? `/gamma-agencies/mailbox/${mailId}?agencyId=${agencyId}`
      : `/gamma-agencies/mailbox/${mailId}`;
    const response = await apiClient.get(endpoint);
    return response.data;
  } catch (error) {
    throw new Error(error);
  }
}

export const sendMail = async (formData) => {
  try {
    const response = await apiClient.post(
      `/gamma-agencies/mailbox`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );
    return response;
  } catch (error) {
    throw new Error(error);
  }
};

export const downloadMailboxAttachment = async (mailId, fileName, agencyId) => {
  try {
    const endpoint = agencyId != null
      ? `/gamma-agencies/mailbox/${mailId}/attachment?agencyId=${agencyId}`
      : `/gamma-agencies/mailbox/${mailId}/attachment`;
    const res = await apiClient.get(
      endpoint,
      { 
        responseType: 'blob',
        headers: {
          "accept": "*/*"
        }
      }
    );
    console.log("response download", res);
    const url = window.URL.createObjectURL(new Blob([res.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName || 'archivo');
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  } catch (e) {
    alert('No se pudo descargar el archivo. Es posible que el archivo no exista o esté dañado.');
  }
};

export const markMailAsRead = async (mailboxDestinationId) => {
  try {
    await apiClient.put(`/gamma-agencies/mailbox/read-status/${mailboxDestinationId}`);
  } catch (error) {
    // silencioso: no interrumpir la UX si falla el marcado
  }
};

export const downloadCertificadoRetentionPDF = async (organizationId, params) => {
  try {
    const { agencyId, cuit, agencyName, number, recordFileId, base, fechaDesde, fechaHasta, taxId } = params;
    const res = await apiClient.get(
      `/gamma-agencies/mailbox/certificado-retencion/pdf`,
      {
        params: { organizationId, agencyId, cuit, agencyName, number, recordFileId, base, fechaDesde, fechaHasta, taxId },
        responseType: 'blob',
        headers: {
          Accept: 'application/pdf',
        },
      }
    );
    const url = window.URL.createObjectURL(new Blob([res.data], { type: 'application/pdf' }));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'CertificadoRetencion.pdf');
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  } catch (e) {
    alert('No se pudo generar el certificado de retención. Intente nuevamente.');
  }
};
